import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { BotCategorizationAction, BotCategoryAction } from '../../../openapi';

export type BotPolicyModifier = 'allow' | 'ignore' | 'block';

export interface BotPolicyOption {
  action: BotCategorizationAction;
  groupAction: BotCategoryAction;
  label: string;
  icon: IconProp;
  modifier: BotPolicyModifier;
}

// The per-bot and category enums number the same policies differently:
// Ignore is 3 per-bot but None (0) on categories, where 0 per-bot means "inherit" — so each option carries both.
// https://bunny-net.atlassian.net/browse/DASH-3596

export const BOT_POLICY_OPTIONS: BotPolicyOption[] = [
  { action: BotCategorizationAction.Allow, groupAction: BotCategoryAction.Allow, label: 'Allow', icon: 'check', modifier: 'allow' },
  { action: BotCategorizationAction.Ignore, groupAction: BotCategoryAction.None, label: 'Ignore', icon: 'eye-slash', modifier: 'ignore' },
  { action: BotCategorizationAction.Block, groupAction: BotCategoryAction.Block, label: 'Block', icon: 'ban', modifier: 'block' },
];

export const getBotPolicyOption = (action: BotCategorizationAction | null | undefined): BotPolicyOption =>
  BOT_POLICY_OPTIONS.find((option) => option.action === action) ?? BOT_POLICY_OPTIONS[1];

export const getBotPolicyOptionByGroupAction = (action: BotCategoryAction | null | undefined): BotPolicyOption =>
  BOT_POLICY_OPTIONS.find((option) => option.groupAction === action) ?? BOT_POLICY_OPTIONS[1];
